import { Mentions } from "antd";
import { MentionProps } from "./type";

function AntMentions(props: MentionProps) {
  return <Mentions {...props}  />;
}

export { AntMentions as Mention };
